
import template from './add_product_version_dialog.html';

var AddProductVersionDialogViewModel = function(page)
{
	var self = this;
	self.page = page;
	this.product_versions = ko.observableArray();
	this.product_version = ko.observable();
	this.product_name = ko.observable();
	this.file_name = ko.observable();
	this.product_id = ko.observable();
	this.product_version_id = ko.observable(null);

}

var AddProductVersionDialogClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AddProductVersionDialogViewModel(this);
	this.name = 'Add Version';

	this.init = function() {
		if (typeof bindings.product_id != "undefined") {
			self.viewModel.product_id(bindings.product_id);
		}

		if (typeof bindings.name != "undefined") {
			self.viewModel.product_name(bindings.name);
		}

		$.postJSON("/grape/list", {schema:'account', tablename: 'product_version', sortfield: 'seq', sortorder: 'DESC',filter: [{ value: bindings.product_id, op: '=', field: 'product_id' }] }, function (res) {
			self.viewModel.product_versions(res.records);
		});
	};

	this.add_version = () => {
		$.postJSON(
			'/psam/api/product/version/save',
			{
				version: this.viewModel.product_version(),
				file_name: this.viewModel.file_name(),
				product_id: this.viewModel.product_id(),
				product_version_id: this.viewModel.product_version_id()
			},
			res => {
				if (res.status !== 'OK')
					return;

				this.viewModel.product_version('');
				this.viewModel.file_name('');
				this.viewModel.product_id('');
				this.viewModel.product_version_id('');
				self.init(false);
			}
		);
	};


	this.delete_product_version = (v,e) => {
		$.postJSON(
			'/product_version/delete',
			{
				product_version_id: v.product_version_id
			},
			res => {
				self.init(false);
			}
		);
	};

	this.add_extra_script = (v,e) => {
		console.log(v);
		Grape.show_dialog(
			'AddExtraScript',
			{version: v.version, product_name: this.viewModel.product_name(), product_id: v.product_id, product_version_id: v.product_version_id }, {
				onClose: (d) => {
					Grape.show_dialog('AddProductVersion',{product_id: v.product_id, name: this.viewModel.product_name()}, {
						onClose: function(d) {
							// TODO reload products?
						}
					});
				}
		});
		this.close();
	};

	this.product_version_promote = function(v,e) {
		$.postJSON('/account_manager/product_version/promote', {
				product_version_id :v.product_version_id,
			}, function(res) {
				self.init(false);
		});
	};

	this.product_version_demote = function(v,e) {
		$.postJSON('/account_manager/product_version/demote', {
				product_version_id :v.product_version_id,
			}, function(res) {
				self.init(false);
		});
	};

	this.product_version_seq_decrement = function(v,e) {
		let seq = 0;
		if (v.seq)
			seq = v.seq-1;

		$.postJSON('/psam/api/product/version/save',
			{
				product_version_id :v.product_version_id,
				seq: seq
			}, function(res) {
				self.init(false);
		});
	};

	this.product_version_seq_increment = function(v,e) {
		let seq = 1;
		if (v.seq)
			seq = v.seq+1;

		$.postJSON('/psam/api/product/version/save',
			{
				product_version_id :v.product_version_id,
				seq: seq
			}, function(res) {
				self.init(false);
		});
	};

	this.onClose = function() {
	};

	this.btnclose = function() {
		self.close(false);
	};


}

//Register the dialog
export default {
	name: 'AddProductVersion',
	dialog_class: AddProductVersionDialogClass,
	template: template
};
